var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0000000{fill:#EAC092;}\r\n\t.st0000001{fill:#FEDBAB;}\r\n\t.st0000002{fill:#EAECF0;}\r\n\t.st0000003{fill:#3688C8;}\r\n\t.st0000004{fill:#26CFAD;}\r\n\t.st0000005{fill:#FFD36C;}\r\n\t.st0000006{fill:#00B192;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0000000",
    d: "M111,369.2v77.4c44.1,1.9,31.3,9.7,108,44.2c9.8,3.8,32.3,10.1,56.4-1c0,0,0,0,0,0l150.6-53.9 c4.9-2.3,29.6-15.7,19.9-40.7c-11.4-26.7-40.7-15.5-43.2-14.7l-78.6,21.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0000001",
    d: "M199.9,401.5l87.6,27.7c15.3,4.3,31.2-4.5,35.5-19.8l0,0c4.3-15.3-4.5-31.2-22-37.7l-77.7-26.4 c0,0-16.6-27.1-56.1-27.1c-24.9,0-46.4,20.2-56.3,37.8v35.2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 354.9,
    className: "st0000002",
    width: 37,
    height: 104.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 354.9,
    className: "st0000003",
    width: 58,
    height: 123
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0000004",
    points: "240.3,102.7 153.6,16 45,124.6 230.6,310.3 333.2,207.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0000005",
    d: "M189,117.5L189,117.5C189,117.4,189,117.4,189,117.5c-10.6,0.7-21.1,5.1-29.3,13.3 c-17.9,17.9-17.9,46.9,0,64.9s46.9,17.9,64.9,0c8.7-8.7,13.1-19.9,13.4-31.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0000000",
    d: "M401,157.8V80.4c-44.1-1.9-31.3-9.7-108-44.2c-9.8-3.8-32.3-10.1-56.4,1c0,0,0,0,0,0l-45.4,16.3l46.9,46.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0000006",
    d: "M45,124.6l36.8-36.8c20.3,20.3,20.3,53.4,0,73.7L45,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0000006",
    d: "M193.8,273.5c20.3-20.3,53.4-20.3,73.7,0l-36.8,36.8L193.8,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0000006",
    d: "M116.8,52.8L153.6,16l36.8,36.8C170.2,73.1,137.1,73.1,116.8,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0000006",
    d: "M290.3,183.8c-6.7,18.4-2.6,39.9,12.1,54.6l30.7-30.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0000001",
    d: "M312.1,125.4l-87.6-27.7c-15.3-4.3-31.2,4.5-35.5,19.8l0,0c-4.3,15.3,4.5,31.2,22,37.7l77.7,26.4l0,0 c0,0,16.6,27.1,56.1,27.1c24.9,0,46.4-20.2,56.3-37.8v-35.2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 67.2,
    className: "st0000002",
    width: 37,
    height: 104.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 49,
    className: "st0000003",
    width: 58,
    height: 123
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.80c7fad8cd77d90d9cb826b6e84b6008.svg";
export { ForwardRef as ReactComponent };